import { useInput } from "react-admin";

import { Choice } from "types";

import * as S from "./ToggleButtonGroupInput.styled";

interface ToggleButtonGroupInputProps {
  source: string;
  label: string;
  disabled?: boolean;
  choices: Choice[];
  defaultValue?: Choice["id"];
}

export const ToggleButtonGroupInput = ({
  source,
  label,
  disabled,
  choices,
  defaultValue
}: ToggleButtonGroupInputProps) => {
  const { field } = useInput({ source, defaultValue: defaultValue ?? choices[0].id });

  return (
    <S.ToggleFormControl>
      <S.ToggleFormLabel>{label}</S.ToggleFormLabel>
      <S.ToggleButtonGroup
        exclusive
        value={field.value}
        onChange={field.onChange}
        color="primary"
        disabled={disabled}
      >
        {choices.map((choice) => (
          <S.ToggleButton key={choice.id} value={choice.id}>
            {choice.name}
          </S.ToggleButton>
        ))}
      </S.ToggleButtonGroup>
    </S.ToggleFormControl>
  );
};
